import { render, staticRenderFns } from "./CollectDetail.vue?vue&type=template&id=e5d24c1e&scoped=true"
import script from "./CollectDetail.vue?vue&type=script&lang=js"
export * from "./CollectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d24c1e",
  null
  
)

export default component.exports